// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__gVoIw","sendOtp":"AuthorizeToLogin_sendOtp__2i9Sv"};